import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  center: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: 'white',
  },
  subtitle: {
    marginTop: theme.spacing(2),
  },
});

class EmptyState extends Component {
  render() {
    // Styling
    const { classes } = this.props;

    // Properties
    const { icon, title, description, button } = this.props;

    return (
      <div className={classes.center}>
        {icon}
        {title && <Typography className={classes.title} variant="h4">{title}</Typography>}
        {description && <Typography className={classes.subtitle} variant="subtitle1">{description}</Typography>}
        {button}
      </div>
    );
  }
}

EmptyState.propTypes = {
  classes: PropTypes.object.isRequired,

  icon: PropTypes.element,
  title: PropTypes.string,
  description: PropTypes.string,
  button: PropTypes.element
};

export default withStyles(styles)(EmptyState);
